const guiColors = {
    'color-scheme': 'dark',

    'ui-primary': '#111111',
    'ui-secondary': '#1e1e1e',
    'ui-tertiary': '#2e2e2e',

    'ui-modal-overlay': '#333333aa',
    'ui-modal-background': '#111111',
    'ui-modal-foreground': '#eeeeee',
    'ui-modal-header-background': '#333333',
    'ui-modal-header-foreground': '#ffffff',

    'ui-white': '#111111',

    'ui-black-transparent': '#ffffff26',

    'text-primary': '#eeeeee',

    'menu-bar-background': '#333333',

    'assets-background': '#111111',

    'input-background': '#1e1e1e',

    'popover-background': '#1e1e1e',

    'badge-background': '#16202c',
    'badge-border': '#203652',

    'fullscreen-background': '#111111',
    'fullscreen-accent': '#111111',

    'page-background': '#111111',
    'page-foreground': '#eeeeee',

    'project-title-inactive': 'var(--ui-secondary)',
    'project-title-hover': '#ffffff3f',

    'link-color': '#44aaff',

    'filter-icon-black': 'invert(100%)',
    'filter-icon-gray': 'grayscale(100%) brightness(1.7)',
    'filter-icon-white': 'brightness(0) invert(100%)',

    'paint-filter-icon-gray': 'brightness(1.7)',
    'mode-toggle-container':'#1f2933',
    'tabswitcher-tabs-equles-true':'#1F1F1F',
    'tabswitcher-tabs-noequles-false':'#2A2A2A',
    'tabswitcher-programe-back':'#1F1F1F',
    'tabswitcher-programe-down-lightordark':'#0D0D0D',
    'tabswitcher-control-first-lightordark':'#1F1F1F',
    'tabswitcher-control-second-lightordark':'#2A2A2A',
    'tabswitcher-control-third-lightordark':'#0D0D0D',
    'tabswitcher-control-fourth-lightordark':'#1F1F1F',
    'tabswitcher-serial-second-lightordark':'#1F1F1F',
    'tabswitcher-serial-first-lightordark':'#2A2A2A',
    'ic-main': '#1a1a1a',          // 主黑（不是纯黑，避免太死）
    'ic-main-light': '#404040',    // 浅黑（用于hover/次级）
    'ic-main-light-very': '#d9d9d9', // 很浅灰（背景层）
    'ic-main-light-pluse': '#f5f5f5' // 极浅灰（接近白）
};

const blockColors = {
    insertionMarker: '#cccccc',
    workspace: '#1e1e1e',
    toolboxSelected: '#1e1e1e',
    toolboxText: '#cccccc',
    toolbox: '#111111',
    flyout: '#111111',
    scrollbar: '#666666',
    valueReportBackground: '#1e1e1e',
    valueReportBorder: '#333333',
    valueReportForeground: '#eeeeee',
    contextMenuBackground: '#111111',
    contextMenuBorder: '#ffffff26',
    contextMenuForeground: '#eeeeee',
    contextMenuActiveBackground: '#2e2e2e',
    contextMenuDisabledForeground: '#666666',
    flyoutLabelColor: '#cccccc',
    checkboxInactiveBackground: '#222222',
    checkboxInactiveBorder: '#c8c8c8',
    buttonBorder: '#c6c6c6',
    buttonActiveBackground: '#222222',
    buttonForeground: '#cccccc',
    zoomIconFilter: 'invert(100%)',
    gridColor: '#484848'
};

export {
    guiColors,
    blockColors
};
